import styled from "styled-components";

interface ITableProps {
  styledRow?: boolean;
}

export const GlobalFilterWrapper = styled.div`
  margin: 10px 0px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr 0.8fr 0.8fr;
  }
  @media screen and (max-width: 630px) {
    display: flex;
    flex-direction: column;
  }
`;

// search input
export const SearchGridItem = styled.div`
  @media screen and (min-width: 961px) {
    width: 50%;
  }
  @media screen and (min-width: 769px) {
    grid-area: 2/1/3/3;
    margin-top: 20px;
  }
  @media screen and (max-width: 768px) {
    grid-area: 2/2/3/4;
  }
`;
// date picker
export const DatePickerGridItem = styled.div`
  /* grid-area: DatePickerGridItem; */
  @media screen and (min-width: 769px) {
    grid-area: 1/1/2/2;
  }
  @media screen and (max-width: 768px) {
    grid-area: 1/1/2/2;
  }
  @media screen and (max-width: 630px) {
    margin-bottom: 10px;
  }
`;
// select input
export const SelectGridItem = styled.div`
  /* max-width: fit-content; */
  /* grid-area: 1/3/2/4; */
`;
// styles for select inputGridItem
export const SelectIncidentTypeGridItem = styled.div`
  @media screen and (min-width: 769px) {
    grid-area: 1/2/2/3;
    margin-right: 10px;
  }
  @media screen and (max-width: 768px) {
    grid-area: 1/2/2/3;
  }
`;
// styles for SelectStatusGridItem
export const SelectStatusGridItem = styled.div`
  @media screen and (min-width: 769px) {
    grid-area: 1/3/2/4;
    margin-right: 10px;
  }
  @media screen and (max-width: 768px) {
    grid-area: 1/3/2/4;
  }
  @media screen and (max-width: 630px) {
    /* grid-area: */
  }
`;
// styles for SelectFacilityGridItem
export const SelectFacilityGridItem = styled.div`
  @media screen and (min-width: 769px) {
    grid-area: 1/4/2/5;
  }
  @media screen and (max-width: 768px) {
    margin-top: 10px;
    grid-area: 2/1/3/2;
  }
`;
// clear filter
export const ClearFilterGridItem = styled.div`
  /* max-width: fit-content; */
  /* border: 1px solid red; */
  @media screen and (min-width: 769px) {
    grid-area: 2/3/3/4;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }
  @media screen and (max-width: 768px) {
    grid-area: 3/1/4/2;
  }
  @media screen and (max-width: 630px) {
    margin: 10px 0;
  }
`;
// add incident
export const AddIncidentGridItem = styled.div`
  @media screen and (min-width: 961px) {
    width: 20%;
  }
  @media screen and (min-width: 769px) {
    grid-area: 2/4/3/5;
    margin-top: 20px;
  }
  @media screen and (max-width: 768px) {
    grid-area: 3/2/4/4;
  }
  /* border: 1px solid blue; */
`;

export const ExportFilterContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 20px;
`;

export const Tr = styled.tr.attrs({})<ITableProps>`
  :nth-child(even) {
    background-color: ${(props) =>
      props.styledRow && "rgba(250, 246, 251, 0.89)"};
  }
`;

export const ExportBTN = styled.select.attrs({
  className: "lg:ml-3 sm:ml-0  rounded border-none focus:outline-none px-5",
})`
  background-color: var(--main-purple-light);
  color: white;
  height: 3rem;
  height: 48px;

  option {
    background-color: white;
    color: black;
  }

  @media screen and (max-width: 768px) {
    /* margin-bottom: 10px; */
  }
`;
export const SelectReportType = styled.select`
  background-color: var(--main-purple-light);
  color: white;
  height: 40px;
  padding: 0 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition:
    /* background-color 0.2s ease, */ box-shadow 0.2s ease;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23FFFFFF%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E");
  background-repeat: no-repeat;
  background-position: right 12px top 50%;
  background-size: 12px auto;
  padding-right: 30px;

  /* &:hover,
  &:focus {
    background-color: var(--main-purple);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  } */

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(var(--main-purple-rgb), 0.3);
  }

  option {
    background-color: white;
    color: #000;
    padding: 8px;
  }

  @media screen and (max-width: 768px) {
    /* width: 100%; */
    /* margin-top: 8px; */
  }
`;

export const BtnExport = styled.button.attrs({
  className: "lg:ml-3 sm:ml-0  rounded border-none focus:outline-none px-5",
})`
  background-color: var(--main-purple-light);
  color: white;
  height: 3rem;
  height: 48px;
  cursor: pointer;
`;

export const TitleBar = styled.div.attrs({
  className: "text-center text-medium font-semibold py-3 mt-5 w-full px-4",
})`
  background-color: var(--primaryPurpleMain);
  color: #fbf8fc;
`;

export const Tag = styled.div.attrs({})`
  background-color: var(--main_purple_light_shade);
  color: white;
  cursor: pointer;
  height: 25px;
  width: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: absolute;
  /* top: 3px; */
  top: -3px;
  right: -10px;
`;
